import { cn } from "@/lib/utils";
import type { ButtonHTMLAttributes, AnchorHTMLAttributes } from "react";

const base =
  "inline-flex items-center justify-center gap-2 rounded-sm text-[0.72rem] font-medium uppercase tracking-[0.18em] transition-all duration-300 disabled:opacity-50";

const variants = {
  solid:
    "bg-primary text-primary-foreground px-7 py-4 hover:bg-forest-deep hover:-translate-y-0.5 hover:shadow-lift",
  gold: "bg-accent text-accent-foreground px-7 py-4 hover:brightness-105 hover:-translate-y-0.5 hover:shadow-lift",
  outline:
    "border border-foreground/25 text-foreground px-7 py-4 hover:border-foreground hover:bg-foreground hover:text-background",
  onDark:
    "border border-primary-foreground/45 text-primary-foreground px-7 py-4 backdrop-blur-[2px] hover:bg-primary-foreground hover:text-forest-deep",
  ghost: "text-foreground px-2 py-2 hover:text-primary",
};

export type ResortButtonVariant = keyof typeof variants;

export function ResortButton({
  variant = "solid",
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: ResortButtonVariant }) {
  return <button className={cn(base, variants[variant], className)} {...props} />;
}

export function ResortLink({
  variant = "solid",
  className,
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement> & { variant?: ResortButtonVariant }) {
  return <a className={cn(base, variants[variant], className)} {...props} />;
}
